import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

export default function ConfirmDialog({ open, onCancel, onConfirm, title, message, confirmText = "Confirm", danger = false, testid = "confirm" }) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel?.()}>
      <DialogContent className="max-w-md" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="text-[#0A1F44]">{title}</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">{message}</p>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onCancel} data-testid={`${testid}-cancel`}>Cancel</Button>
          <Button
            onClick={onConfirm}
            data-testid={`${testid}-ok`}
            className={danger ? "bg-[#C8102E] hover:bg-[#a50d25] text-white" : "bg-[#0A1F44] hover:bg-[#091a3a] text-white"}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
